import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { startGoogleOAuth } from "../../auth/oauthFlow";
import "../../styles/components/GoogleOAuthButton.css";

function getOAuthStartErrorMessage(t, detail) {
  if (detail === "supabase_oauth_not_configured") {
    return t("oauth_not_configured", {
      defaultValue: "Google sign-in is not configured yet.",
    });
  }

  return t("oauth_start_failed", {
    defaultValue: "Google sign-in could not start. Please try again.",
  });
}

export default function GoogleOAuthButton({ className = "" }) {
  const { t } = useTranslation();
  const [isStarting, setIsStarting] = useState(false);

  const handleClick = async () => {
    if (isStarting) return;

    setIsStarting(true);
    try {
      await startGoogleOAuth();
    } catch (error) {
      setIsStarting(false);
      alert(getOAuthStartErrorMessage(t, error?.detail || error?.message));
    }
  };

  return (
    <button
      type="button"
      className={`google-oauth-button ${className}`.trim()}
      onClick={handleClick}
      disabled={isStarting}
    >
      <span className="google-oauth-button__mark" aria-hidden="true">
        G
      </span>
      <span className="google-oauth-button__label">
        {isStarting
          ? t("oauth_starting", { defaultValue: "Opening Google..." })
          : t("oauth_continue_google", {
              defaultValue: "Continue with Google",
            })}
      </span>
    </button>
  );
}
